// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconQuestion } from '@ni/nimble-components/dist/esm/icons/question';
import { wrap } from '../utilities/react-wrapper';

export { type IconQuestion };
export const NimbleIconQuestion = wrap(IconQuestion);